var map = {
	"./bg.png": 88853,
	"./制造&商贸企业.png": 48982,
	"./制造&商贸企业hover.png": 32823,
	"./危化运输.png": 33617,
	"./危化运输hover.png": 96981,
	"./商砼运输.png": 84233,
	"./商砼运输hover.png": 10380,
	"./城市环卫.png": 84980,
	"./城市配送.png": 29469,
	"./大件运输.png": 34587,
	"./家具运输.png": 80407,
	"./家具运输hover.png": 44636,
	"./快消品运输.png": 74448,
	"./快速运输.png": 92429,
	"./挖机运输.png": 44326,
	"./数字仓储.png": 60045,
	"./数字政务.png": 19895,
	"./汽贸运输.png": 29825,
	"./渣土运输.png": 89029,
	"./港口物流.png": 54504,
	"./煤炭运输.png": 38276,
	"./生物冷链.png": 50812,
	"./生鲜冷链.png": 8545,
	"./生鲜冷链hover.png": 65173,
	"./行业协会.png": 94399,
	"./钢铁运输.png": 82470,
	"./零担专线.png": 63750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53485;